import { useQuery } from '@tanstack/react-query';
import { getMetrics } from '../lib/api';
import { Card, ErrorBox, Loading, PageHeader, formatDate } from '../components/ui';

export function DashboardPage(): JSX.Element {
  const q = useQuery({ queryKey: ['metrics'], queryFn: getMetrics });

  if (q.isLoading) return <Loading />;
  if (q.isError) return <ErrorBox message={(q.error as Error).message} />;

  const m = q.data!;
  const tiles = [
    { label: 'Total users', value: m.totalUsers },
    { label: 'Drivers', value: m.totalDrivers },
    { label: 'Suspended', value: m.totalSuspended },
    { label: 'Rides published', value: m.ridesPublished },
    { label: 'Rides today', value: m.ridesToday },
    { label: 'Bookings today', value: m.bookingsToday },
    { label: 'Bookings pending', value: m.bookingsPending },
    { label: 'Premium active', value: m.premiumActive },
  ];
  const alerts = [
    { label: 'Open anti-abuse flags', value: m.openAntiAbuseFlags, tone: 'warning' },
    { label: 'Open reports', value: m.openReports, tone: 'warning' },
    { label: 'Failed notifications', value: m.failedNotifications, tone: 'danger' },
  ];

  return (
    <>
      <PageHeader title="Dashboard" subtitle="At-a-glance state of the platform." />
      <section className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-4">
        {tiles.map((t) => (
          <Card key={t.label}>
            <p className="text-xs text-text-soft">{t.label}</p>
            <p className="mt-1 text-2xl font-bold text-brand-navy">{t.value}</p>
          </Card>
        ))}
      </section>
      <section className="mb-6 grid grid-cols-1 gap-3 md:grid-cols-3">
        {alerts.map((a) => (
          <Card key={a.label}>
            <p className="text-xs text-text-soft">{a.label}</p>
            <p
              className={
                'mt-1 text-2xl font-bold ' +
                (a.value > 0
                  ? a.tone === 'danger'
                    ? 'text-destructive'
                    : 'text-warning'
                  : 'text-brand-navy')
              }
            >
              {a.value}
            </p>
          </Card>
        ))}
      </section>
      <Card>
        <p className="text-xs text-text-soft">Last notification outbox drain</p>
        <p className="mt-1 text-sm font-medium text-brand-navy">
          {formatDate(m.lastNotificationDrainAt)}
        </p>
      </Card>
    </>
  );
}
